import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './PWAInstallPrompt.css';

const PWAInstallPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isAndroid, setIsAndroid] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Check if running in standalone mode (PWA already installed)
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
                         window.navigator.standalone ||
                         document.referrer.includes('android-app://');

    if (isStandalone) {
      return;
    }

    // Detect mobile device
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isiOSDevice = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    const isAndroidDevice = /android/i.test(userAgent);

    setIsIOS(isiOSDevice);
    setIsAndroid(isAndroidDevice);

    // Only show on mobile devices
    if (!isiOSDevice && !isAndroidDevice) {
      return;
    }

    // Check if prompt was dismissed (cookie check)
    const promptDismissed = getCookie('pwa_prompt_dismissed');
    if (promptDismissed) {
      return;
    }

    // Check if already shown in this session
    const shownInSession = sessionStorage.getItem('pwa_prompt_shown');
    if (shownInSession) {
      return;
    }

    // ONLY show if user is on a login-related page
    const isLoginPage = location.pathname === '/login' || 
                        location.pathname.includes('login') ||
                        location.pathname === '/signup';
    
    if (!isLoginPage) {
      return;
    }

    // Show the prompt after a short delay
    const timer = setTimeout(() => {
      setShowPrompt(true);
      sessionStorage.setItem('pwa_prompt_shown', 'true');
    }, 1500); // Show after 1.5 seconds

    return () => clearTimeout(timer);
  }, [location.pathname]);

  const handleClose = () => {
    setShowPrompt(false);
    // Set cookie for 30 days
    setCookie('pwa_prompt_dismissed', 'true', 30);
  };

  // Cookie helper functions
  const setCookie = (name, value, days) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  };

  const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  if (!showPrompt) {
    return null;
  }

  return (
    <div className="pwa-install-prompt-overlay">
      <div className="pwa-install-prompt">
        <button className="pwa-close-button" onClick={handleClose} aria-label="Close">
          ✕
        </button>
        
        <div className="pwa-icon">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="8" fill="white"/>
            <path d="M20 12L20 28M20 28L26 22M20 28L14 22" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        <div className="pwa-content">
          <h3 className="pwa-title">Install DIZEE App</h3>
          {isIOS ? (
            <p className="pwa-description">
              Tap the <span className="share-icon">
                <svg width="12" height="16" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 0L8 12M8 0L4 4M8 0L12 4M2 8V18H14V8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span> share button below, then select <strong>"Add to Home Screen"</strong>
            </p>
          ) : (
            <p className="pwa-description">
              Install DIZEE app for quick access and a better experience
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;

